export enum BlogUrlList {
    fullData = "/api/article-full-data",
    update = "/api/article-update",
    save = "/api/article-save",
    articleData = "/api/articles",
    articles = "/api/articles",
    delete = "/api/article-delete"
}